module.exports = __webpack_public_path__ + "img/small_close_icon.e64feff9.svg";